module.exports = __webpack_public_path__ + "img/sign-37.91044739.jpg";